import { clearApiKey } from "@tc/ui-typesense-client"

/** Session storage key for dismissed announcement banner state */
export const ANNOUNCEMENT_DISMISSED_KEY = "dismissed-announcement-banner"

/** Session storage key for the requests page filter state */
export const REQUESTS_FILTER_STATE_KEY = "requestsFilterState"

/** Session storage key for the templates page filter state */
export const TEMPLATES_FILTER_STATE_KEY = "templatesFilterState"

/** Session storage key for the transfer requests page filter state */
export const TRANSFER_REQUESTS_FILTER_STATE_KEY = "transferRequestsFilterState"

/** Session storage key to track when OCA user explicitly clears the default "Approved" filter */
export const OCA_DEFAULT_FILTER_CLEARED_KEY = "oca_default_filter_cleared"

/**
 * Perform all session cleanup before signing out.
 * Centralizes cleanup to avoid duplication across signOut wrappers.
 */
export const signOutCleanup = (): void => {
  clearApiKey()
  sessionStorage.removeItem(ANNOUNCEMENT_DISMISSED_KEY)
  sessionStorage.removeItem(REQUESTS_FILTER_STATE_KEY)
  sessionStorage.removeItem(TEMPLATES_FILTER_STATE_KEY)
  sessionStorage.removeItem(TRANSFER_REQUESTS_FILTER_STATE_KEY)
  sessionStorage.removeItem(OCA_DEFAULT_FILTER_CLEARED_KEY)
}
